import { useState } from 'react';
import axios from 'axios';

interface Check {
  rule?: string;
  field?: string;
}

interface ChecksSummaryItem {
  rule: string;
  field: string;
  failed_rows: number[];
  failed: boolean;
}

export interface ValidationResponse {
  validation_id: string;
  checks_summary: ChecksSummaryItem[];
}

export const useDataValidationValidateFile = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const validateFile = async (params: {
    owner: string;
    file_id: string;
    checks: Check[];
    row_number_field?: string;
  }): Promise<{ data_validation_validate_file: ValidationResponse }> => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        '/api/v1/validation/data_validation_validate_file',
        {
          params,
        }
      );

      // Match the structure expected by components using this hook
      return {
        data_validation_validate_file: response.data,
      };
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error('Failed to validate file')
      );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    validateFile,
    loading,
    error,
  };
};
